module.exports = __webpack_public_path__ + "static/media/timer_play.c5f36e4f.svg";